import React, { useEffect, useState } from 'react';
import cx from 'classnames';
import styles from './SettingsContent.module.scss';
import { useUserContext } from '../../../../context/UserContext';
import { MyProfile } from '../MyProfile/MyProfile';
import { Notifications } from '../Notifications/Notifications';
import { Preferences } from '../Preferences/Preferences';
import MyLibraryButton from '../../../../components/MyLibraryButton/MyLibraryButton';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import { useTranslation } from 'react-i18next';
import Content from '../../../../components/Content/Content';

const SettingsContent = () => {
  const location = useLocation();

  const { user, appConfig } = useUserContext();

  const { t } = useTranslation();

  const [selectedTab, setSelectedTab] = useState(0);

  const OPTIONS = {
    MY_PROFILE: {
      name: 'account.settings.my_profile',
      children: <MyProfile />,
    },
    NOTIFICATIONS: {
      name: 'account.settings.notifications',
      children: <Notifications />,
    },
    PREFERENCES: {
      name: 'account.settings.viewer_settings',
      children: <Preferences />,
    },
    // INTEGRATIONS: {
    //   name: 'Integrations',
    //   children: <Integrations />,
    // },
  };

  const [options, setOptions] = useState([
    OPTIONS.MY_PROFILE,
    OPTIONS.PREFERENCES,
    //, OPTIONS.INTEGRATIONS
  ]);

  const handleSelectTab = index => {
    setSelectedTab(index);
  };

  useEffect(() => {
    if (appConfig) {
      setOptions([
        OPTIONS.MY_PROFILE,
        OPTIONS.NOTIFICATIONS,
        OPTIONS.PREFERENCES,
        // OPTIONS.INTEGRATIONS
      ]);

      if (location.search.includes('notifications')) {
        handleSelectTab(1);
      }
    }
  }, [appConfig]);

  return (
    <Content className={cx(styles.mainContainer)}>
      <div className={styles.settingsContainer}>
        <div className={styles.settingsHeader}>
          <h1 className={styles.settingsTitle}>{t('account.settings.title')}</h1>
          <span>
            {user?.userFullName}
            {appConfig?.name && <> / {appConfig?.name}</>}
          </span>
        </div>
        <div className={styles.settingsTabs}>
          {options.map((el, index) => {
            return (
              <MyLibraryButton
                key={el?.name}
                className={cx(styles.tabButton, selectedTab === index && styles.activeTab)}
                text={t(el?.name)}
                onClick={() => handleSelectTab(index)}
              />
            );
          })}
        </div>
        <div>{options[selectedTab].children}</div>
      </div>
    </Content>
  );
};

export default SettingsContent;
